;(function($,window,undefined) {

	var Member = {

		$window: $(window),
		$groups: null,
		groups_index: 0,
		groups_max: 0,
		target_group: null,
		scroll_top: 0,
		scroll_btm: 0,

		/* ===============================================
		 * ページ読み込み後、Commonから一度だけ呼び出されます
		 * =============================================== */
		setupOnce: function(){
			Common.trace("Member -> setupOnce");

			var $window = Common.Window.$window;

			this.setCategoryChange();

			// $(".block__boxList").each(function(i,ele){
      //
			// 	var $img = $(ele).find("img");
			// 	var img_w = $img.width();
			// 	var img_h = $img.height();
      //
			// 	if(img_w > img_h){
			// 		$img.addClass("is-wh");
			// 	}else{
			// 		$img.addClass("is-hw");
			// 	}
      //
			// });

		},

		setThumbSize: function(){

			$(".block-talent .block__img").each(function(i,ele){
				var $_img = $(ele).find("img");
				var _w = $_img.width();
				var _h = $_img.height();

				if( _w > _h ){
					$_img.addClass("is-wh");
				}
				else if( _h > _w ){
					$_img.addClass("is-hw");
				};

				setTimeout(function(){
					$_img.addClass("is-anim");
				}, 400);

			});

		},

		setCategoryChange: function(){

			// エレメント
			var $block_box = $(".block__box"); // リストを入れ込むボックス
			var $block_navList_list = $(".block__navList__list"); // ソートナビゲーション
			var $block_boxList = $block_box.find(".block__boxList"); // 現在表示されているリスト
			var $block_boxList_clone = $( $block_boxList.clone() ); // クローンオリジナル
			var $block_boxList_clone_clone; // ソートごとにクローンされる

			// ハッシュを取得する
			var _hash = window.location.hash;
			var _hash = _hash.replace( /#/g , "" ) ;

			var _selector_active = "is-active";

			// ソートナビゲーションがクリックされたら実行
			$block_navList_list.on("click", function(){

				var $this = $(this);
				var _category = $this.attr("data-category");

				// ボックス内の古いリストを削除する
				$block_box.find(".block__boxList").remove();

				// ソートナビゲーションのカレント変更
				$block_navList_list.removeClass(_selector_active);
				$this.addClass(_selector_active);

				// 新規追加用のリストをクローンする
				$block_boxList_clone_clone = $block_boxList_clone.clone();

				// カテゴリーが一致したらボックスに追加する
				$block_boxList_clone_clone.each(function(i,ele){

					var $ele = $(ele);

					// all の場合は全て表示する
					if(_category == "all"){
						$ele.appendTo( $block_box );
						$ele.addClass( _selector_active );
					}
					// カテゴリー指定の場合、一致するカテゴリーのリストだけ表示する
					else{
						if($ele.hasClass("is-" + _category)){
							$ele.appendTo( $block_box );
							$ele.addClass(_selector_active);
						};
						// $block_boxList.removeClass(_selector_active);

					}

				});

				Member.setThumbSize();

			});

			if(_hash != ""){
				$(".block__navList__list.is-" + _hash).addClass(_selector_active);
				$(".block__navList__list.is-" + _hash).trigger("click");
			}
			else{
				$(".block__navList__list.is-all").addClass(_selector_active);
				$(".block__navList__list.is-all").trigger("click");
			};

		}

	};

	Common.Page = Member;

})(jQuery,window);

